import React from "react";
import { Routes } from "react-router-dom";
const CustomSwitch = ({ children }) => {
    return (
        <><Routes>{children}</Routes></>
    );
};

export default CustomSwitch;
